import { StyledTable } from "./styled";
import Table from "../Table";
import { COLUMNS } from "../../Component/WinloseTable/config";
import { FC, ReactElement } from "react";
import { OnChangeFn, SortingState } from "@tanstack/react-table";

const WinloseTable: FC<{
  data: any[];
  context?: Record<string, any>;
  Footer?: ReactElement;
  isLoading?: boolean;
  sorting?: SortingState;
  onSortingChange?: OnChangeFn<SortingState>;
  manualSorting?: boolean;
}> = ({
  data = [],
  context,
  Footer,
  isLoading = false,
  sorting,
  onSortingChange,
  manualSorting = false,
}) => {
  return (
    <StyledTable>
      <Table<any>
        isLoading={isLoading}
        data={data}
        columns={COLUMNS}
        context={context}
        Footer={Footer}
        enableSorting
        sorting={sorting}
        onSortingChange={onSortingChange}
        manualSorting={manualSorting}
      />
    </StyledTable>
  );
};

export default WinloseTable;
